var _line, _path, _line2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaneLine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 20,
    viewBox: "0 0 112 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 9.5,
    x2: 45.6667,
    y2: 9.5,
    stroke: "url(#paint0_linear_115_16099)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6265 10.4587L54.416 17.1253L52.7493 17.1253L54.8546 10.4587L50.3883 10.4587L48.9993 12.9587L47.7493 12.9587L48.5827 9.20866L47.7493 5.45866L48.9993 5.45866L50.3883 7.95866L54.8546 7.95866L52.7493 1.29199L54.416 1.29199L58.6265 7.95866L63.166 7.95866C63.8564 7.95866 64.416 8.51833 64.416 9.20866C64.416 9.89899 63.8564 10.4587 63.166 10.4587L58.6265 10.4587Z",
    fill: "url(#paint1_linear_115_16099)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 65.666,
    y1: 9.5,
    x2: 111.333,
    y2: 9.5,
    stroke: "url(#paint2_linear_115_16099)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_16099",
    x1: 0,
    y1: 10.5,
    x2: 45.6667,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_115_16099",
    x1: 56.0827,
    y1: 1.29199,
    x2: 56.0827,
    y2: 17.1253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_115_16099",
    x1: 65.666,
    y1: 10.5,
    x2: 111.333,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneLine);
export default __webpack_public_path__ + "static/media/planeLine.f52cc0904cddfc00c61d4efca3cf7146.svg";
export { ForwardRef as ReactComponent };